type IconProps = { name: string; size?: number };
export function Icon({ name, size = 18 }: IconProps) {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
  };
  const paths: Record<string, React.ReactNode> = {
    grid: (
      <>
        <rect x="3" y="3" width="7" height="7" rx="1" data-amazi-id={"crm/src/features/crm/icons.tsx:16:9"} />
        <rect x="14" y="3" width="7" height="7" rx="1" data-amazi-id={"crm/src/features/crm/icons.tsx:17:9"} />
        <rect x="3" y="14" width="7" height="7" rx="1" data-amazi-id={"crm/src/features/crm/icons.tsx:18:9"} />
        <rect x="14" y="14" width="7" height="7" rx="1" data-amazi-id={"crm/src/features/crm/icons.tsx:19:9"} />
      </>
    ),
    users: (
      <>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" data-amazi-id={"crm/src/features/crm/icons.tsx:24:9"} />
        <circle cx="9" cy="7" r="4" data-amazi-id={"crm/src/features/crm/icons.tsx:25:9"} />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" data-amazi-id={"crm/src/features/crm/icons.tsx:26:9"} />
      </>
    ),
    briefcase: (
      <>
        <rect x="3" y="7" width="18" height="13" rx="2" data-amazi-id={"crm/src/features/crm/icons.tsx:31:9"} />
        <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18M10 12v2h4v-2" data-amazi-id={"crm/src/features/crm/icons.tsx:32:9"} />
      </>
    ),
    check: (
      <>
        <rect x="3" y="4" width="18" height="17" rx="2" data-amazi-id={"crm/src/features/crm/icons.tsx:37:9"} />
        <path d="m7 12 3 3 7-7M8 1v3M16 1v3" data-amazi-id={"crm/src/features/crm/icons.tsx:38:9"} />
      </>
    ),
    bell: (
      <>
        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" data-amazi-id={"crm/src/features/crm/icons.tsx:43:9"} />
      </>
    ),
    chart: (
      <>
        <path d="M3 3v18h18" data-amazi-id={"crm/src/features/crm/icons.tsx:48:9"} />
        <path d="m7 16 4-5 3 2 5-7" data-amazi-id={"crm/src/features/crm/icons.tsx:49:9"} />
      </>
    ),
    search: (
      <>
        <circle cx="11" cy="11" r="7" data-amazi-id={"crm/src/features/crm/icons.tsx:54:9"} />
        <path d="m20 20-4-4" data-amazi-id={"crm/src/features/crm/icons.tsx:55:9"} />
      </>
    ),
    plus: (
      <>
        <path d="M12 5v14M5 12h14" data-amazi-id={"crm/src/features/crm/icons.tsx:60:9"} />
      </>
    ),
    arrow: (
      <>
        <path d="M5 12h14M13 6l6 6-6 6" data-amazi-id={"crm/src/features/crm/icons.tsx:65:9"} />
      </>
    ),
    calendar: (
      <>
        <rect x="3" y="4" width="18" height="17" rx="2" data-amazi-id={"crm/src/features/crm/icons.tsx:70:9"} />
        <path d="M16 2v4M8 2v4M3 10h18" data-amazi-id={"crm/src/features/crm/icons.tsx:71:9"} />
      </>
    ),
  };
  return <svg {...common} data-amazi-id={"crm/src/features/crm/icons.tsx:75:10"}>{paths[name] ?? paths.grid}</svg>;
}
